<template>
  <a-drawer
    :title="videoJson && videoJson.name"
    width="1000"
    :visible="visible"
    :closable="false"
    :footer="false"
    @close="onClose"
  >
    <div class="tool-view">
      <!-- 弹簧 -->
      <div style="flex: 1;"></div>
      <!-- 同步视频 -->
      <a-button @click="touchSync" style="margin-right: 12px;">同步视频</a-button>
      <!-- 上传按钮 -->
      <Upload
        accept=".mp4"
        uploadSource="SeriesDrawerBatch"
        :multiple="true"
        :disabled="isLoading"
        :fileList="batchFileList"
        :uploadBucket="$pub.BUCKET_PRI()"
        :beforeUploadPro="beforeUploadBatchPro"
        style="display: inline-block;"
        @click="touchBatchUpload"
      >
        <template #up-title>批量上传</template>
      </Upload>
    </div>
    <!-- 列表 -->
    <a-table
      class="table-view"
      :data-source="dataSource"
      :columns="columns"
      :row-key="record => record.id"
      :pagination="pagination"
      :loading="isLoading"
      @change="handleTableChange"
    >
      <!-- 自定义行内容 -->
      <template #bodyCell="{ column, record }">
        <!-- 文件名 -->
        <template v-if="column.key === 'name'">
          <div style="max-width: 100px;">
            <a @click="touchPreview(record)" v-if="record.url">{{ record.name }}</a>
            <span v-else>未上传</span>
          </div>
        </template>
        <!-- 540P -->
        <template v-else-if="column.key === 'amazon_540_url'">
          <div style="max-width: 100px;">
            <a @click="touchPreview(record, 540)" v-if="record.amazon_540_url">{{ record.name }}</a>
            <span v-else>未上传</span>
          </div>
        </template>
        <!-- 720P -->
        <template v-else-if="column.key === 'amazon_720_url'">
          <div style="max-width: 100px;">
            <a @click="touchPreview(record, 720)" v-if="record.amazon_720_url">{{ record.name }}</a>
            <span v-else>未上传</span>
          </div>
        </template>
        <!-- 1080P -->
        <template v-else-if="column.key === 'amazon_1080_url'">
          <div style="max-width: 100px;">
            <a @click="touchPreview(record, 1080)" v-if="record.amazon_1080_url">{{ record.name }}</a>
            <span v-else>未上传</span>
          </div>
        </template>
        <!-- 抖小状态 -->
        <template v-else-if="column.key === 'v_audit_status'">
          <span style="white-space: nowrap;">
            {{ (AuditStatusTt.find(item => item.value === record[column.key]) || {}).text || '-' }}
            <a-tooltip v-if="record.v_audit_msg">
              <template #title>{{ record.v_audit_msg }}</template>
              <info-circle-outlined />
            </a-tooltip>
          </span>
        </template>
        <!-- 快小状态 -->
        <template v-else-if="column.key === 'ks_audit_status'">
          <span style="white-space: nowrap;">
            {{ (AuditStatusTt.find(item => item.value === record[column.key]) || {}).text || '-' }}
            <a-tooltip v-if="record.ks_audit_msg">
              <template #title>{{ record.ks_audit_msg }}</template>
              <info-circle-outlined />
            </a-tooltip>
          </span>
        </template>
        <!-- 操作 -->
        <template v-else-if="column.key === 'operation'">
          <Upload
            v-if="visible"
            accept=".mp4"
            uploadSource="SeriesDrawer"
            :uploadBucket="$pub.BUCKET_PRI()"
            :beforeUploadPro="beforeUploadPro"
            :uploadResult="(fileJson, res) => { uploadResult(fileJson, res, record) }"
            style="display: inline-block;"
          >
            <template #up-slot>
              <a class="operation-item" v-if="record.url">更换</a>
              <a class="operation-item" v-else>上传</a>
            </template>
          </Upload>
        </template>
        <template v-else>
          {{ record[column.key] || '-' }}
        </template>
      </template>
    </a-table>
    <!-- 预览 -->
    <PreviewVideoProModal ref="RefPreviewModal"></PreviewVideoProModal>
    <!-- 加载 -->
    <Loading :loading="isSyncAllLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { Modal } from 'ant-design-vue'
import Pub from '@/utils/public'
import { onBeforeMount, reactive, ref, createVNode } from 'vue'
import { nextTick } from 'process'
import Upload from '@/components/Upload'
import PreviewVideoProModal from '@/components/preview/PreviewVideoProModal'
import { message } from 'ant-design-vue'
import { AuditStatusTt } from '@/utils/constantList'
import { videoList, videoUpload, existVideo, syncVideo } from '@/api/admin'
import { uploadCustom } from '@/utils/upload'
import Loading from '@/components/Loading'

// 视频预览
let RefPreviewModal = ref(null)
// 视频信息
let videoJson = ref(null)
// 显示
let visible = ref(false)
// 滚动范围
let scrollX = ref(0)
// 加载
let isLoading = ref(false)
let isSyncAllLoading = ref(false)
// 批量上传列表
let batchFileList = ref([])
// 每轮批量上传ID
let batchUploadId = ref(null)
// 数据源
let dataSource = ref([])
// 选中
let selectedRowKeys = ref([])
let selectedRows = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 20,
  size: 'small',
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '集数',
    dataIndex: 'eq_number',
    key: 'eq_number',
  },
  // {
  //   title: '文件名',
  //   dataIndex: 'name',
  //   key: 'name',
  // },
  {
    title: '540P',
    dataIndex: 'amazon_540_url',
    key: 'amazon_540_url',
  },
  {
    title: '720P',
    dataIndex: 'amazon_720_url',
    key: 'amazon_720_url',
  },
  {
    title: '1080P',
    dataIndex: 'amazon_1080_url',
    key: 'amazon_1080_url',
  },
  {
    title: '上传日期',
    dataIndex: 'upload_date',
    key: 'upload_date',
    width: 200
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    fixed: 'right',
    width: 220
  }
])

// 显示
function showDrawer (data) {
  // 清空
  selectedRowKeys.value = []
  selectedRows.value = []
  dataSource.value = [{}]
  // 记录
  videoJson.value = data
  // 显示
  visible.value = true
  // 延迟处理
  nextTick(() => {
    // 获取列表
    getVideoList()
  })
}

// 关闭
function onClose () {
  if (!isLoading.value && !isSyncAllLoading.value) {
    // 重置
    pagination.current = 1
    pagination.pageSize = 20
    visible.value = false
  }
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  // 获取列表
  getVideoList()
}

// 预览
function touchPreview (record, quality) {
  RefPreviewModal.value.showModal({id: record.drama_id, eq: record.eq_number, quality: quality})
}

// 点击批量上传
function touchBatchUpload () {
  // 清空
  batchUploadId.value = ''
  batchFileList.value = []
}

// 批量上传
function beforeUploadBatchPro (file, fileList) {
  // 每轮上传，都在首次处理文件列表
  if (file.uploadId != batchUploadId.value) {
    // 进入加载
    isLoading.value = true
    // 记录
    batchUploadId.value = file.uploadId
    // 取出所有文件名
    var eqs = []
    const isOK = fileList.every(item => {
      // 分割
      const names = item.name.split('.')
      // 取出0位置
      const eq = names[0]
      // 文件命名有问题
      if (!Pub.REG_IS_POSITIVE_INTEGER(eq)) {
        Modal.error({
          title: `【${item.name}】未匹配到剧集`,
          content: '请核实文件命名方式后再上传',
          okText: '好 的'
        })
        return false
      }
      // 检查文件类型
      if (!file.type.includes('video')) {
        Modal.error({
          title: `【${item.name}】非视频类型`,
          content: '请核实文件类型后再上传',
          okText: '好 的'
        })
        return false
      }
      // 文件集数是否大于总集数
      // if (Number(eq) > pagination.total) {
      if (Number(eq) > videoJson.value.total_ep) {
        Modal.error({
          title: `【${item.name}】大于剧集总集数`,
          content: '请核实文件命名方式后再上传',
          okText: '好 的'
        })
        return false
      }
      // 取出0位置
      eqs.push(eq)
      // 记录
      item.eq = eq
      // 返回
      return true
    })
    // 停止上传
    if (!isOK) {
      // 停止加载
      isLoading.value = false
      return false
    }
    // 转为数字数组
    eqs = eqs.map(Number)
    // 去重
    const repeatEqs = Array.from(new Set(eqs))
    // 是否数量一样
    if (repeatEqs.length !== eqs.length) {
      Modal.error({
        title: '部分剧集存在重复文件',
        content: '请核实文件命名方式后再上传',
        okText: '好 的'
      })
      // 停止加载
      isLoading.value = false
      return false
    }
    // 获取已存在剧集的集数
    existVideo({ drama_id: videoJson.value.id }).then(res => {
      const { code, data } = res
      if (code === 0) {
        // 便利
        const exeqs = []
        data.forEach(item => {
          // 是否存在
          if (eqs.includes(item)) { exeqs.push(item) }
        })
        // 检查是否有以存在的剧集需要覆盖
        if (exeqs.length) {
          Modal.confirm({
            title: `${exeqs.join('、')}集已存在`,
            content: createVNode('div', { style: 'color: red;' }, '新视频将覆盖原视频，你还要继续吗？'),
            cancelText: '取 消',
            okText: '继 续',
            onOk () {
              // 开始上传
              batchUpload(fileList)
            },
            onCancel () {
              // 停止加载
              isLoading.value = false
            }
          })
        } else {
          // 开始上传
          batchUpload(fileList)
        }
      } else {
        // 停止加载
        isLoading.value = false
        message.error(message)
      }
    }).catch(err => {
      // 停止加载
      isLoading.value = false
      message.error(err.message)
    })
  }
  // 禁止上传
  return false
}

// 同步视频
function touchSync () {
  syncVideo({ id: videoJson.value.id }).then(res => {
    const { code } = res
    if (code === 0) {
      message.success('请求成功，后台同步中...')
    } else {
      message.error(res.message)
    }
  })
}

// 开始上传
function batchUpload (fileList) {
  // 总数量
  const total = fileList.length
  // 成功集数
  var seqs = []
  // 失败集数
  var feqs = []
  // 递归上传
  uploadFile(0, fileList, seqs, feqs, total)
}

// 递归上传
function uploadFile (index, fileList, seqs, feqs, total) {
  // 需要上传的问题
  const file = fileList[index]
  // 提示上传结果
  message.info(`正在上传【${file.name}】`)
  // 开始上传
  uploadCustom({ file, eq: file.eq }, (fileJson, res) => {
    // 上传结果判断
    if (fileJson.status === 'done') {
      // 上传成功
      const params = {
        drama_id: videoJson.value.id,
        eq_number: fileJson.eq,
        name: fileJson.name,
        url: fileJson.url,
        key: fileJson.key,
        duration: fileJson.duration,
        size: fileJson.size,
        preview_url: fileJson.url,
        vid: fileJson.vid,
        // size: res.res.size
      }
      videoUpload(params).then(res => {
        const { code } = res
        if (code === 0) {
          // 提示上传结果
          message.success(`【${file.name}】上传成功，当前进度【${index + 1} / ${total}】`)
          // 记录成功
          seqs.push(fileJson.eq)
          // 刷新结果
          reloadBatchUploadResult(index, fileList, seqs, feqs, total)
        } else {
          // 提示上传结果
          message.error(`【${file.name}】上传失败，当前进度【${index + 1} / ${total}】`)
          // 记录失败
          feqs.push(fileJson.eq)
          // 刷新结果
          reloadBatchUploadResult(index, fileList, seqs, feqs, total)
        }
      }).catch(() => {
        // 提示上传结果
        message.error(`【${file.name}】上传失败，当前进度【${index + 1} / ${total}】`)
        // 记录失败
        feqs.push(fileJson.eq)
        // 刷新结果
        reloadBatchUploadResult(index, fileList, seqs, feqs, total)
      })
    } else if (fileJson.status === 'error') {
        // 提示上传结果
        message.error(`【${file.name}】上传失败，当前进度【${index + 1} / ${total}】`)
        // 记录失败
        feqs.push(fileJson.eq)
        // 刷新结果
        reloadBatchUploadResult(index, fileList, seqs, feqs, total)
    }
  }, Pub.BUCKET_PRI(), 'SeriesDrawerBatch')
}

// 刷新上传结果
function reloadBatchUploadResult (index, fileList, seqs, feqs, total) {
  // 上传完了，进行结算
  if (index === (total - 1)) {
    // 停止加载
    isLoading.value = false
    // 检查是否有失败的
    if (feqs.length) {
      // 有失败的
      Modal.error({
        title: '部分集数上传失败，请重新上传！',
        content: `${feqs.join('、')}`,
        okText: '好 的'
      })
    } else {
      // 没有失败的
      Modal.success({
        title: '上传成功！',
        okText: '好 的'
      })
      // 更新列表
      getVideoList()
    }
  } else {
    // 继续上传
    uploadFile(index + 1, fileList, seqs, feqs, total)
  }
}

// 准备上传
function beforeUploadPro (file) {
  if (!file.type.includes('video')) {
    message.error('请上传视频类型的文件')
    return false
  }
  isLoading.value = true
  return true
}

// 上传结果
function uploadResult (fileJson, res, record) {
  // 上传结果判断
  if (fileJson.status === 'done') {
    const params = {
      drama_id: record.drama_id,
      eq_number: record.eq_number,
      name: fileJson.name,
      url: fileJson.url,
      key: fileJson.key,
      duration: fileJson.duration,
      size: fileJson.size,
      preview_url: fileJson.url,
      // size: res.res.size
    }
    videoUpload(params).then(res => {
      isLoading.value = false
      const { code } = res
      if (code === 0) {
        // 成功
        if (record.id) {
          message.success('更新成功')
        } else {
          message.success('上传成功')
        }
        // 刷新列表
        getVideoList()
      } else {
        // 失败
        message.error(res.message)
      }
    }).catch(() => {
      // 失败
      if (record.id) {
        message.error('更新失败')
      } else {
        message.error('上传失败')
      }
    })
  } else if (fileJson.status === 'error') {
    isLoading.value = false
    if (record.id) {
      message.error('更新失败')
    } else {
      message.error('上传失败')
    }
  } else {
    // console.log('正在上传');
  }
}

// 获取列表
function getVideoList () {
  isLoading.value = true
  const params = {
    drama_id: videoJson.value.id,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  videoList(params).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      // 清空
      selectedRowKeys.value = []
      selectedRows.value = []
      // 重置列表数据
      dataSource.value = data.data
      pagination.total = data.total
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 抛出
defineExpose({
  showDrawer
})

</script>

<style scoped>
.tool-view {
  display: flex;
}
.table-view {
  margin-top: 20px;
}

</style>